<template>
  <section class="c-section c-section--panel-courses gray-lightx">
    <h2 class="sec-medium fs-30 w-sbold mb-4 d-none d-lg-block">
      Mis cursos
    </h2>

    <b-skeleton-wrapper :loading="courses.loading">
      <template #loading>
        <div class="c-courses-grid">
          <div
            v-for="course of [1,2,3,4,5,6,7,8,9]"
            :key="`course-sk-${course}`"
            class="c-courses-grid__item"
          >
            <b-card>
              <div class="row gy-2">
                <div class="col-12">
                  <b-skeleton width="100%" height="200px"></b-skeleton>
                </div>
                <div class="col-12">
                  <b-skeleton width="90%" height="20px"></b-skeleton>
                </div>
              </div>
            </b-card>
          </div>
        </div>
      </template>

      <template v-if="courses.data.length">
        <section class="mb-5">
          <div class="c-courses-grid">
            <div
              v-for="course of courses.data"
              :key="`course-${course.id}`"
              class="c-courses-grid__item"
            >
              <router-link :to="course.nextLection" class="d-block">
                <div class="c-curse">
                  <figure class="c-curse__figure">
                    <img
                      :src="course.thumbnail"
                      alt=""
                      class="h-100 w-100 of--cover"
                    />
                  </figure>
                  <div class="c-curse__text p-4 h-100 w-100">
                    <p>
                      {{course.title}}
                    </p>
                    <p class="mb-2 d-flex">
                      <span class="d-flex flex-row align-items-center">
                        <Icon icon="carbon:time" class="c-curse__icon" />
                        <span
                          class="c-curse__icon">
                          {{course.duration}} hrs
                        </span>
                      </span>
                    </p>

                    <p v-if="course.progress >= 100">
                      <span class="d-flex flex-row align-items-center me-1">
                        <Icon icon="akar-icons:circle-check"
                          class="pri-color fs-21 me-1" />
                        <span
                          class="c-curse__icon">
                          Completado
                        </span>
                      </span>
                    </p>

                    <div
                      v-else
                      class="row w-100 align-items-center"
                    >
                      <div class="col-10 pe-0">
                        <div class="progress w-100">
                          <div class="progress-bar" :style="`width:${course.progress}%`">
                          </div>
                        </div>
                      </div>
                      <div class="col-2 pe-0">
                        <span class="fs-14">{{course.progress}}%</span>
                      </div>
                    </div>
                  </div>
                  <p class="c-curse__play">
                    <span class="d-flex align-items-center justify-content-center">
                      Ver el curso<Icon icon="akar-icons:play" class="ms-2 fs-30" />
                    </span>
                  </p>
                </div>
              </router-link>
            </div>
          </div>
        </section>

        <b-pagination
          v-model="courses.paged"
          :total-rows="courses.paginationTotal"
          :per-page="courses.perPage"
          @change="getCourses()"
          align="center"
        ></b-pagination>
      </template>
      <template v-else>
        <section class="text-center">
          <p class="mb-4 text-center sec-medium">
            Aun no tiene cursos inscritos
            <Icon icon="noto:sad-but-relieved-face" class="ms-2" />
          </p>

          <router-link to="/cursos" class="c-button c-button--primary d-inline-block">
            Explorar nuestros cursos
          </router-link>
        </section>
      </template>
    </b-skeleton-wrapper>
  </section>
</template>

<script>
export default {
  data() {
    return {
      courses: {
        data: [],
        loading: false,

        paged: 1,
        perPage: 1,
        paginationTotal: 5,
      },
    };
  },
  computed: {
    userData() {
      return this.$store.getters.stateUser;
    },
    userAuthToken() {
      return this.$store.getters.token;
    },
  },
  mounted() {
    this.getCourses();
  },
  methods: {
    getCourses() {
      this.courses.loading = true;

      fetch(`${process.env.VUE_APP_API}/users/${this.userData.id}/courses`, {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${this.userAuthToken}`,
        },
      })
        .then((res) => {
          if (res.status === 201 || res.status < 300) {
            return res.json();
          }

          return res.text().then((text) => { throw new Error(text); });
        })
        .then((response) => {
          if (response.status) {
            this.courses.data = response.data.courses;
            this.courses.paginationTotal = response.data.pagination.total;
          }
        })
        .catch((err) => {
          throw err;
        })
        .finally(() => {
          this.courses.loading = false;
        });
    },
  },
};
</script>
